/**
 * The scene-complete transition: a scan-flash that fades the classical mesh
 * world toward the quantum-computer interior. M2 lands the dramatic overlay;
 * wiring up the actual SDF interior renderer is the next milestone.
 */
export interface SceneComplete {
  play(): void;
  hide(): void;
  dispose(): void;
}

export function createSceneComplete(parent: HTMLElement): SceneComplete {
  const el = document.createElement('div');
  el.className = 'scene-complete';
  el.innerHTML =
    '<div class="sc-flash"></div><div class="sc-title">ENTER THE<br/>QUANTUM COMPUTER</div>';
  parent.appendChild(el);

  return {
    play() {
      el.classList.add('active');
    },
    hide() {
      el.classList.remove('active');
    },
    dispose() {
      el.remove();
    },
  };
}
